<template>
  <div class="teaching-evaluate-apply-define-setup-select">
    <DataGridBubble :visible.sync="visible"
                    :visible-arrow="false"
                    transition="dialog-fade"
                    placement="bottom-start"
                    popper-class="teaching-evaluate-apply-define-setup-select-popper"
                    @open.once="loadSetupInfo"
                    @opened="onSetupOpened">
      <template #reference>
        <div :class="['holder', {'is-active': visible}]"
             @click.stop="toggleVisible">
          <template v-if="value">
            <el-tag size="mini"
                    type="primary">{{value.site}}</el-tag>
            <span class="label">{{value.course}}</span>
          </template>
          <template v-else>
            <span class="placeholder">请选择课程</span>
          </template>
        </div>
      </template>
      <div class="popper-main"
           v-loading="loading"
           element-loading-text="数据加载中，请稍等...">
        <template v-if="setupInfo">
          <div class="popper-header">
            <el-input v-model="keyword"
                      size="mini"
                      type="text"
                      clearable
                      placeholder="搜索课程"></el-input>
          </div>
          <div class="popper-body">
            <DataGrid ref="grid"
                      size="mini"
                      height="auto"
                      border="none"
                      highlight-hover-row
                      show-overflow="title"
                      show-header-overflow="title"
                      resizable
                      :data="filterItems"
                      :row-class-name="resolveRowClass"
                      @cell-click="onChangeSetup">
              <DataGridColumn title="教学点"
                              field="site"
                              width="100"
                              sortable></DataGridColumn>
              <DataGridColumn title="课程名称"
                              field="course"
                              sortable></DataGridColumn>
              <DataGridColumn title="设置状态"
                              field="isExist"
                              width="100"
                              align="center"
                              sortable>
                <template #default="{row}">
                  <el-tag v-if="row.isExist"
                          size="mini">已设置</el-tag>
                  <el-tag v-else
                          size="mini"
                          type="info">未设置</el-tag>
                </template>
              </DataGridColumn>
              <DataGridColumn title="开启评教"
                              field="isSetup"
                              width="100"
                              align="center"
                              sortable>
                <template #default="{row}">
                  <div @click.stop>
                    <el-switch :value="row.isSetup"
                               @change="val => onSetupChange(row, val)"></el-switch>
                  </div>
                </template>
              </DataGridColumn>
              <template #empty>
                <template v-if="keyword">
                  <span>没有匹配的课程</span>
                </template>
                <template v-else>
                  <span>没有可配置课程</span>
                </template>
              </template>
            </DataGrid>
          </div>
        </template>
        <template v-else>
          <Hint v-if="!loading"
                type="error">
            <div>评教自定义数据加载失败</div>
            <el-button type="text"
                       @click="loadSetupInfo">重新加载</el-button>
          </Hint>
        </template>
      </div>
    </DataGridBubble>
  </div>
</template>

<script>
import DataGridBubble from '../../../../../../../../elements/grid/DataGridBubble'
import DataGrid from '../../../../../../../../elements/DataGrid'
import DataGridColumn from '../../../../../../../../elements/DataGridColumn'
import Hint from '../../../../../../../../elements/Hint'
export default {
  name: 'TeachingEvaluateApplyDefineSetupSelect',
  components: {
    DataGridBubble,
    DataGrid,
    DataGridColumn,
    Hint
  },
  props: {
    value: Object,
    evaluation: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      visible: false,
      loading: false,
      setupInfo: null,
      keyword: '',
      committing: false
    }
  },
  computed: {
    filterItems () {
      let setupInfo = this.setupInfo
      if (setupInfo) {
        let items = setupInfo.items
        if (items) {
          let keyword = this.keyword
          if (keyword) {
            return items.filter(item => (item.course || '').includes(keyword))
          } else {
            return items
          }
        }
      }
    }
  },
  methods: {
    toggleVisible () {
      this.visible = !this.visible
    },
    loadSetupInfo () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/teaching/evaluate/apply/define/setupInfo',
        method: 'post',
        data: this.$qs.stringify({
          id: this.evaluation.id
        })
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.setupInfo = response.data['setupInfo'] || {}
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    },
    onSetupChange (defineSetup, isSetup) {
      this.committing = true
      this.$ajax({
        url: '/workspace/manager/teaching/evaluate/apply/define/switch',
        method: 'post',
        data: this.$qs.stringify({
          id: this.evaluation.id,
          courseId: defineSetup.id,
          isSetup: isSetup
        })
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.$message.success(response.data['message'])
              this.$nextTick(() => {
                this.$set(defineSetup, 'isSetup', isSetup)
              })
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.committing = false
      })
    },
    resolveRowClass ({row}) {
      if (row === this.value) {
        return 'theme-text theme-light-bg'
      }
    },
    onChangeSetup ({row}) {
      this.$emit('input', row)
      this.$nextTick(() => {
        this.visible = false
      })
    },
    onSetupOpened () {
      this.$nextTick(() => {
        const grid = this.$refs.grid
        if (grid) {
          grid.recalculate().then(() => {
            const select = this.value
            if (select) {
              grid.scrollToRow(select)
            }
          })
        }
      })
    }
  },
  watch: {
    setupInfo: function (val) {
      const select = this.value
      if (select) {
        let items = val.items || []
        let getSelect = items.find(item => item.id === select.id)
        this.$emit('input', getSelect)
      }
    }
  }
}
</script>

<style lang="scss">
  .teaching-evaluate-apply-define-setup-select {
    .data-grid-bubble {
      display: flex;
      .el-popover__reference {
        display: flex;
        .holder {
          position: relative;
          display: block;
          min-width: 320px;
          height: 32px;
          font-size: 12px;
          font-weight: bold;
          line-height: 28px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          border: 2px solid #ebeef5;
          border-radius: 20px;
          padding: 0 30px 0 10px;
          cursor: pointer;
          box-sizing: border-box;
          transition: all .3s;
          &:after {
            content: '';
            position: absolute;
            right: 10px;
            top: 50%;
            width: 0;
            height: 0;
            border-top: 5px solid #909399;
            border-left: 5px solid transparent;
            border-right: 5px solid transparent;
            border-bottom: none;
            margin-top: -2px;
            transition: all .3s;
          }
          &:hover,
          &.is-active {
            box-shadow: inset 0 0 3px rgba(0,0,0,.1);
            border-color: #dcdfe6;
            &:after {
              border-top-color: #606266;
            }
          }
          &.is-active {
            &:after {
              transform: rotate(180deg);
            }
          }
          & > .label {
            margin-left: 4px;
          }
          & > .placeholder {
            color: #909399;
            padding-left: 4px;
          }
        }
      }
    }
  }
  .teaching-evaluate-apply-define-setup-select-popper {
    margin-top: 5px!important;
    width: 540px!important;
    padding: 5px!important;
    box-sizing: border-box;
    .popper-main {
      min-height: 300px;
      & > .popper-header {
        padding: 10px;
        border-bottom: 1px solid #ebeef5;
        .el-input {
          .el-input__inner {
            border-radius: 20px;
          }
        }
      }
      & > .popper-body {
        height: 360px;
        .vxe-table {
          .vxe-table--header-wrapper {
            .vxe-table--header {
              .vxe-header--row {
                background-color: #f9f9fa;
              }
            }
          }
          .vxe-table--body-wrapper {
            .vxe-table--body {
              .vxe-body--row {
                cursor: pointer;
                .vxe-body--column {
                  .vxe-cell {
                    .el-switch {
                      transform: scale(.72) translateY(-14%);
                    }
                  }
                }
              }
            }
          }
        }
      }
      .layout-hint {
        height: 300px;
      }
    }
  }
</style>
